import { useState, useEffect } from 'react';
import { api } from '../lib/api';

export interface Trade {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  category: string;
  sort_order: number;
  is_active: boolean;
  created_at: string;
}

export const useTrades = () => {
  const [trades, setTrades] = useState<Trade[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadTrades();
  }, []);

  const loadTrades = async () => {
    try {
      setLoading(true);
      setError(null);

      const data = await api.get<Trade[]>('/trades', { is_active: true });

      setTrades(data || []);
    } catch (err: any) {
      console.error('Error loading trades:', err);
      setError(err.message || 'Failed to load trades');
    } finally {
      setLoading(false);
    }
  };

  const getTradesByCategory = (category: string) => {
    return trades.filter(trade => trade.category === category);
  };

  const getTradeBySlug = (slug: string) => {
    return trades.find(trade => trade.slug === slug);
  };

  const getTradeByName = (name: string) => {
    return trades.find(trade => trade.name === name);
  };

  const categories = Array.from(new Set(trades.map(trade => trade.category)));

  return {
    trades,
    loading,
    error,
    getTradesByCategory,
    getTradeBySlug,
    getTradeByName,
    categories,
  };
};
